import * as React from "react";
import { PdfIcons } from "./pdfIcons";
import { WerkzeugKnopf } from "./Werkzeugleiste";
import type { KommentarSteuerung } from "./useDokumentKommentare";
import "./pdfEditor.css";

/**
 * Knöpfe rund um die Kommentare — in der Ansehen-Leiste (`PdfDocumentView`)
 * und im Editor (Gruppe „Ansicht“). Ohne Fluent (User 04.10.2026): dieselben
 * `WerkzeugKnopf`e wie der Rest der Leiste; ob nur das Symbol zu sehen ist,
 * entscheidet die Leiste selbst.
 */

/** Werkzeug „Kommentar“. Hält eine Textauswahl fest: der Klick darf sie nicht aufheben. */
export const KommentarWerkzeugKnopf: React.FC<{
    aktiv: boolean;
    onClick: () => void;
    disabled?: boolean;
}> = ({ aktiv, onClick, disabled }) => (
    <WerkzeugKnopf
        aktiv={aktiv}
        icon={PdfIcons.kommentar}
        onMouseDown={(e) => e.preventDefault()}
        onClick={onClick}
        disabled={disabled}
        label="Kommentar"
        title="Text auswählen, Bereich aufziehen oder auf eine Stelle klicken — der Kommentar bleibt in KMVS, nicht im PDF"
    />
);

/** Kommentare ein-/ausblenden, mit Anzahl offener Kommentare. */
export const KommentareUmschalter: React.FC<{ kommentare: KommentarSteuerung }> = ({ kommentare }) => {
    const { sichtbar, setSichtbar, anzahlOffen } = kommentare;
    return (
        <WerkzeugKnopf
            aktiv={sichtbar}
            icon={sichtbar ? PdfIcons.kommentareAn : PdfIcons.kommentareAus}
            onClick={() => {
                if (sichtbar) kommentare.setOffen(null);
                setSichtbar(!sichtbar);
            }}
            label={`Kommentare (${anzahlOffen})`}
            title={sichtbar ? "Kommentare ausblenden" : "Kommentare einblenden"}
        />
    );
};

/** „2 Kommentare ohne Stelle“ — Seite beim Umbau gelöscht; Klick öffnet den ersten oben auf Seite 1. */
export const KommentareOhneStelle: React.FC<{ kommentare: KommentarSteuerung }> = ({ kommentare }) => {
    const n = kommentare.ohneStelle.length;
    if (!n) return null;
    return (
        <button
            type="button"
            className="pdfx-textknopf"
            onClick={() => {
                kommentare.setSichtbar(true);
                kommentare.setOffen(kommentare.ohneStelle[0].id);
            }}
            title="Ihre Seite wurde gelöscht — der Text ist erhalten"
        >
            {PdfIcons.kommentarOhneStelle}
            {n === 1 ? "1 Kommentar ohne Stelle" : `${n} Kommentare ohne Stelle`}
        </button>
    );
};
